// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B99nJ","tabsBox":"styles_tabsBox__3512E","createButton":"styles_createButton__3wQLf"};